<template>
    <div class="parametersWrapper">
        <div class="parametersForm">
            <b-form inline>
                <tree-view-item :items="getArcgisLayers"></tree-view-item>
                <b-button @click="submitLayersOptions" variant="success" class="rounded-0 border-0 btnIcon"><font-awesome-icon icon="sync-alt" class="icon" size="lg"></font-awesome-icon></b-button>
            </b-form>
        </div>
    </div>
</template>

<script lang="ts">
    import { Vue } from 'vue-property-decorator';
    import { namespace } from 'vuex-class';
    import Component from 'vue-class-component';
    import map from '@/types/map/type-map';
    import arcgisLayer from '@/types/map/type-arcgis-layer';
    import TreeViewItem from './TreeViewItem.vue'

    import { library } from "@fortawesome/fontawesome-svg-core";
    import { faTimes, faCog, faEye, faEyeSlash, faAngleDoubleRight, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
    import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

    import CartoMod from '@/store/CartoMod';

    const CartoModule = namespace("CartoMod");

    library.add(faCog, faTimes, faSyncAlt, faEye, faEyeSlash, faAngleDoubleRight);

    @Component({
        name: 'arcgis-tree-view-widget',
        components: {
            FontAwesomeIcon,
            TreeViewItem
        }
    })
    export default class ArcgisTreeViewWidget extends Vue {

        @CartoModule.State
        private map!: map
        @CartoModule.State
        private arcgisFeatures! : object[]
        @CartoModule.Getter
        private getArcgisLayers!: arcgisLayer[];
        @CartoModule.Mutation
        private setArcgisLayers!: (layers: any[]) => void;
        @CartoModule.Mutation
        setLayersParametersJSON!: (layersJSON: string) => void;
        @CartoModule.Mutation
        setMapKey!: () => void;

        showParams(layers: any) {
            if (this.map.layersParametersJSON == null) {
                this.setArcgisLayers(this.startCascade(layers));
            }
            else {
                this.setArcgisLayers(JSON.parse(this.map.layersParametersJSON))
            }
        }

        startCascade(layerList: any[]) {
            var rootLayers = layerList.filter((layer) => { return layer.parentLayerId === -1 });
            var formattedLayerList: any[] = [];
            rootLayers.forEach(rootLayer => {
                formattedLayerList.push(this.childrenFormat(rootLayer, layerList))
            });
            return formattedLayerList;
        }

        childrenFormat(parent: any, layerList: any[]) {
            var children = layerList.filter((child) => { return child.parentLayerId === parent.id });
            var obj: arcgisLayer = {
                id: parent.id,
                visible: parent.defaultVisibility,
                sublayers: [],
                title: parent.name,
                selected: false,
                selectorDcx: null,
                isFolder: children.length > 0,
                isOpen: false
            };
            children.forEach(layer => {
                obj.sublayers.push(this.childrenFormat(layer, layerList))
            });
            obj.sublayers.reverse();

            if (obj.sublayers.length === 0) {
                delete obj.sublayers;
            }
            return obj
        }


        //Add parentId for reverse cascadeCheck function
        //formatLayers(layers: arcgisLayer[]) {
        //    for (let layer of layers) {
        //        for (let sublayer of layer.sublayers) {
        //            sublayer.parentId = layer.id
        //            if (sublayer.isFolder == true) {
        //                this.formatLayers(sublayer.sublayers)
        //            }
        //        }
        //    }
        //    return layers
        //}


        submitLayersOptions() {
            //console.log(this.getArcgisLayers)
            //console.log(this.arcgisFeatures)
            this.setLayersParametersJSON(JSON.stringify(this.getArcgisLayers))
            this.setMapKey();
        }
    }



</script>

<style scoped>
    .paramBtn {
        margin: 5px;
        display: flex;
        padding: 6px 7px;
        z-index: 10;
    }

    .btnIcon {
        margin: 5px;
        display: flex;
        padding: 6px 7px;
        background: #FFFFFF !important;
        color: #6E6E6E;
    }

        .btnIcon .icon {
            margin: auto;
        }

        .btnIcon:hover {
            background-color: #6E6E6E;
            color: #D9D9D9;
        }

    .treeSelect {
        width: 90%;
    }

    .labelClassName {
        margin-left: auto !important;
        justify-content: space-between;
    }

    .treeviewIcon {
        z-index: 15;
        margin-left: auto;
        color: #FFFFFF;
    }

    .vue-treeselect__menu {
        position: relative;
        outline: 1px solid #FFFFFF !important;
        border-radius: 0 !important;
    }

    .parametersWrapper {
        height: auto;
        width: auto;
        background-color: rgba(255,255,255,0.9);
        z-index: 10;
        top: 0;
        right: 0;
    }

    parametersForm {
    }

    .paramInput {
        border-radius: 0 !important;
        margin: 0px 2.5px;
        border: 1px solid #FFFFFF;
    }
</style>